(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-main-cart"]) return;
  try {
    
  if (!customElements.get('cart-session-timer')) {
    class CartSessionTimer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const value = this.querySelector('[data-cart-timer-value]');
        if (!value) return;

        const durationMs = 15 * 60 * 1000;
        const storageKey = 'fiami-cart-session-timer-end';
        let endTime;

        try {
          endTime = Number(sessionStorage.getItem(storageKey));
          if (!endTime) {
            endTime = Date.now() + durationMs;
            sessionStorage.setItem(storageKey, String(endTime));
          }
        } catch {
          endTime = Date.now() + durationMs;
        }

        const update = () => {
          const remainingSeconds = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
          const minutes = Math.floor(remainingSeconds / 60);
          const seconds = remainingSeconds % 60;
          value.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

          if (remainingSeconds === 0 && this.timerId) {
            window.clearInterval(this.timerId);
            this.timerId = undefined;
          }
        };

        update();
        this.timerId = window.setInterval(update, 1000);
      }

      disconnectedCallback() {
        if (this.timerId) window.clearInterval(this.timerId);
      }
    }

    customElements.define('cart-session-timer', CartSessionTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
